import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    fontSize: pxToRem(16),
    textAlign: 'center',
  },
  actionColumn: {
    color: theme.palette.accentMessage,
    fontSize: pxToRem(16),
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: pxToRem(16),
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        verticalAlign: 'middle',
      },
    },
  },
  infoIcon: {
    position: 'relative',
    fontSize: pxToRem(16),
    marginLeft: pxToRem(5),
    marginTop: pxToRem(2),
    float: 'right',
    color: theme.palette.themePrimary,
  },
  statement: {
    height: pxToRem(20),
    width: pxToRem(320),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  chevronRight: {
    paddingLeft: pxToRem(7),
  },
  textStatement: {
    fontWeight: 'normal',
  },
});
